import useMapQueries from "./useMapQueries";
import useGroupMemberships from "../../../../hooks/useGroupMemberships";

const useMapMethods = () => {
  const groupMemberships = useGroupMemberships();
  const { getNearbyFeatures } = useMapQueries();

  // Order determines order in which layers are drawn.
  const addFeatureLayersToMap = ({ featureLayers, map }) => {
    map.addMany([
      featureLayers.graphicsLayer,
      featureLayers.lcpLayer,
      featureLayers.addressLayer,
      featureLayers.parcelLayer,
      featureLayers.conduitLayer,
      featureLayers.strandLayer,
      featureLayers.fiberCableLayer,
      featureLayers.polesLayer,
      featureLayers.spliceClosureLayer,
      featureLayers.structureLayer,
      featureLayers.photoPointLayer,
    ]);
  };

  const renderGreenfieldGraphic = async ({
    event,
    featureLayers,
    Graphic,
    view,
  }) => {
    featureLayers.graphicsLayer.removeAll();
    const geometry = event.mapPoint;
    let nearbyFeatures = await getNearbyFeatures(geometry, featureLayers);
    if (!nearbyFeatures) {
      const pointGraphic = new Graphic({
        geometry: geometry,
        symbol: {
          type: "simple-marker",
          color: [7, 176, 19],
          outline: {
            color: [104, 112, 121],
            width: 1,
          },
        },
        popupTemplate: {
          title: "Greenfield Photo Point",
          actions: [
            {
              title: "Edit",
              id: "editGreenfield",
              className: "esri-icon-edit",
            },
            {
              title: "View Photos",
              id: "viewPhotos",
              className: "esri-icon-media",
            },
          ],
        },
      });
      // Add the graphic to the graphics layer.
      featureLayers.graphicsLayer.add(pointGraphic);

      // Open the popup on the point graphic.
      view.popup.open({
        features: [pointGraphic],
        location: pointGraphic.geometry,
      });
    }
  };

  // Watch for changes in layer visibility, then update it in browser storage.
  const watchLayerVisibility = ({
    watchUtils,
    featureLayers,
    saveLayerVisibility,
  }) => {
    Object.keys(featureLayers).forEach((layerName) => {
      watchUtils.watch(featureLayers[layerName], "visible", () => {
        saveLayerVisibility({
          layerName: layerName,
          value: featureLayers[layerName]?.visible,
        });
      });
    });
  };

  // Add check for auditor groups to render the audit button.
  const showAuditButton = () => {
    if (
      groupMemberships.isPrimary ||
      groupMemberships.isAuditorContractor ||
      groupMemberships.isAuditorSplicer ||
      groupMemberships.isAuditPrimary
    ) {
      document.getElementById("auditButton").style["display"] = "block";
    }
  };

  return {
    addFeatureLayersToMap,
    renderGreenfieldGraphic,
    watchLayerVisibility,
    showAuditButton,
  };
};

export default useMapMethods;
